import React from "react";
import { useIntl } from "react-intl";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import Chip from "@mui/material/Chip";
import { getServiceTypeLanguageIdByName } from "../../modules/ticket/ticketConstants";

const TicketFormHeader = ({ values, page, serviceTypes = [] }) => {
  const { formatMessage } = useIntl();

  const serviceTypeId = parseInt(values.serviceType, 10);
  const service = serviceTypes.find((type) => type.id === serviceTypeId);

  return (
    <Box
      sx={{
        ml: 0,
        mr: 0,
      }}
    >
      <Box
        sx={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
        }}
      >
        <Typography variant="h5">
          {formatMessage({ id: "ticket.create.new.title" })}
        </Typography>
        <Typography sx={{ textAlign: "end", mr: 2 }}>
          {`${formatMessage({ id: "ticket.create.new.step" })} ${page} / 3`}
        </Typography>
      </Box>
      <Box sx={{ textAlign: "end" }}>
        {page > 1 && service && (
          <Chip
            label={formatMessage({
              id: getServiceTypeLanguageIdByName(service.name),
            })}
          />
        )}
      </Box>
    </Box>
  );
};

export default TicketFormHeader;
